module.exports = __webpack_public_path__ + "img/keiko-fujimori.8b32f5af.png";